import * as z from "zod";

export const formSchema = z.object({
  tableName: z.string().min(2, "First name must be at least 2 characters"),
  employeesRequired: z
    .number()
    .min(1, "At least 1 employee needs to be required"),
  billPrice: z.number().min(0),
  // Null means nobody has said how many guests fit yet, which a printed bid
  // reports as an incomplete headcount rather than as zero seats.
  guestsAccommodated: z
    .number()
    .int("Guests must be a whole number")
    .min(0, "Guests cannot be negative")
    .nullable(),
  employeePay: z.number().min(1, "Dealer pay must be at least $1"),
  allowsMultipleAssignments: z.boolean(),
  allowsOverlappingEvents: z.boolean().optional(),
  description: z.string().optional(),
  isTable: z.boolean(),
  requestable: z.boolean(),
  isManager: z.boolean(),
  isFlatRate: z.boolean(),
});
